import { collection, getDocs, orderBy, query, setDoc, doc } from 'firebase/firestore';
import { db } from '../../sdk_initialization';

const COLLECTION_BUSINESS_TYPES = 'lookupBusinessType';

const DEFAULT_BUSINESS_TYPES = [
  'Art Collections',
  'Books',
  'Clothing',
  'Decorations',
  'Ethnic Crockery',
  'Financial Services',
  'Fragrances',
  'Furniture',
  'Gifts',
  'Jewlary',
  'Non-Profit',
  'Other',
  'Packaged Food',
  'Toys',
];

const slugify = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');

export const getBusinessTypes = async () => {
  // Fetch ordered by name
  const q = query(collection(db, COLLECTION_BUSINESS_TYPES), orderBy('name'));
  const snap = await getDocs(q);
  let types = snap.docs.map(d => d.get('name') || d.id);

  // Seed defaults in development if empty
  if (types.length === 0 && import.meta.env.DEV) {
    try {
      await seedDefaultBusinessTypes();
    } catch (e) {
      console.warn('Lookup seed skipped (permission or network):', e?.message || e);
    }
    const snap2 = await getDocs(q);
    types = snap2.docs.map(d => d.get('name') || d.id);
  }

  return types;
};

export const seedDefaultBusinessTypes = async () => {
  // Idempotent seeding using deterministic slugs as doc IDs
  const ops = DEFAULT_BUSINESS_TYPES.map(async (name) => {
    const id = slugify(name);
    await setDoc(doc(db, COLLECTION_BUSINESS_TYPES, id), { name }, { merge: true });
  });
  await Promise.all(ops);
};
